import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutModule } from 'app/shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { accountsRoutes } from './accounts.routes';
import { AccountsComponent } from './accounts.component';

@NgModule({
  imports: [LayoutModule, SharedModule, TranslateModule, RouterModule.forRoot(accountsRoutes)],
  declarations: [AccountsComponent],
  providers: []
})
export class AccountsModule {}
